import styled from '@emotion/styled/macro';

// eslint-disable-next-line import/prefer-default-export
export const Heading = styled.h2`
    text-align: center;
    font-size: ${props => props.theme.fontSize.large};
    color: ${props => props.theme.colours.textDark};
    font-family: ${props => props.theme.fonts.gtWalsheimProMedium};
    font-weight: 500;
    line-height: 28px;
    margin-top: ${props => props.theme.spacing.xsmall};
    margin-bottom: ${props => props.theme.spacing.medium};
`;
